import { ValidationError } from '@components/team-channel-section';
import { EventTeam } from '@domain/eventTeam';

export const DISTRIBUTION_MODE_ONLINE = 'online';
export const DISTRIBUTION_MODE_OFFLINE = 'offline';
export const DISTRIBUTION_MODE_ONLINE_AND_OFFLINE = 'online_and_offline';

export type DistributionMode =
  | typeof DISTRIBUTION_MODE_ONLINE
  | typeof DISTRIBUTION_MODE_OFFLINE
  | typeof DISTRIBUTION_MODE_ONLINE_AND_OFFLINE;

// Sales-quota modes (same string values the legacy admission modal used, so the BE mapping is
// unchanged). Declared here rather than imported from the legacy `input-select-channels` so the new
// section stays self-contained when the legacy modal is removed (B2B-1703).
export const CHANNEL_QUOTA_UNLIMITED = 'unlimited';
export const CHANNEL_QUOTA_PER_CHANNEL = 'channel';
export const CHANNEL_QUOTA_ALL = 'all';

export type ChannelQuotaMode =
  | typeof CHANNEL_QUOTA_UNLIMITED
  | typeof CHANNEL_QUOTA_PER_CHANNEL
  | typeof CHANNEL_QUOTA_ALL;

export interface DistributionAccessCodeValue {
  enabled: boolean;
  code: string;
}

export interface DistributionChannelLimitValue {
  enabled: boolean;
  /** Sales-quota mode: no caps / per-channel caps / one cap shared by every selected channel. */
  quotaMode: ChannelQuotaMode;
  /** Cap applied to all selected channels in the `all` mode (string for the input; '' when unset). */
  limitAllChannels: string;
  /** Explicit ids of the channels the offer is sold on (the "Sales channels" multi-select). */
  selectedChannelIds: string[];
  /** Team/channel structure + per-channel caps (per-channel mode). */
  channels: EventTeam;
}

export interface DistributionValue {
  mode: DistributionMode;
  accessCode?: DistributionAccessCodeValue;
  channelLimit?: DistributionChannelLimitValue;
}

export interface DistributionSectionProps {
  value: DistributionValue;
  onChange: (next: Partial<DistributionValue>) => void;
  open: boolean;
  onToggleOpen: () => void;
  disabled?: boolean;
  channelErrors?: ValidationError[];
  /** Error for the channel-limit block (no channel selected / invalid "same for all" cap). */
  channelLimitError?: string;
  channelLimitLoading?: boolean;
  accessCodeError?: boolean;
  dataTestId?: string;
}
